import { CheckCircleOutlined } from '@ant-design/icons'

export function SuccessMessage(props) {
  const { message } = props

  return (
    message ?
    <>
      <div className = "success-message">
        <CheckCircleOutlined className = "success-icon"/>
        { message }
      </div>
      <br/>
    </> :
    undefined
  )
}
